/* Adventskalender-vælger (Adleap, 2026-09-29). Se snippets/advent-picker.liquid. */
(function () {
  if (customElements.get('advent-picker')) return;

  var money = new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' });
  function fmt(cents) {
    return money.format(cents / 100);
  }

  class AdventPicker extends HTMLElement {
    connectedCallback() {
      this.max = parseInt(this.dataset.max, 10) || 4;
      this.boxVariant = parseInt(this.dataset.boxVariant, 10);
      this.boxAvailable = this.dataset.boxAvailable === 'true';
      this.chainVariant = parseInt(this.dataset.chainVariant, 10) || null;
      this.chainAvailable = this.dataset.chainAvailable === 'true';
      try {
        this.items = JSON.parse(this.querySelector('[data-advent-items]').textContent);
      } catch (e) {
        this.items = [];
      }
      this.byId = {};
      this.items.forEach(function (it) {
        this.byId[it.id] = it;
      }, this);
      this.chosen = [];

      this.select = this.querySelector('[data-advent-select]');
      this.addBtn = this.querySelector('[data-advent-add]');
      this.list = this.querySelector('[data-advent-list]');
      this.count = this.querySelector('[data-advent-count]');
      this.total = this.querySelector('[data-advent-total]');
      this.submit = this.querySelector('[data-advent-submit]');
      this.submitLabel = this.querySelector('[data-advent-submit-label]');
      this.error = this.querySelector('[data-advent-error]');

      this.fillOptions();
      this.select.addEventListener('change', this.render.bind(this));
      this.addBtn.addEventListener('click', this.add.bind(this));
      this.list.addEventListener('click', this.onListClick.bind(this));
      this.submit.addEventListener('click', this.addToCart.bind(this));
      this.render();
    }

    label(it) {
      return it.label ? it.name + ' (' + it.label + ')' : it.name;
    }

    fillOptions() {
      this.items.forEach(function (it) {
        var o = document.createElement('option');
        o.value = it.id;
        o.textContent = this.label(it) + ' – ' + fmt(it.price) + (it.available ? '' : ' (udsolgt)');
        o.disabled = !it.available;
        this.select.appendChild(o);
      }, this);
    }

    add() {
      var id = parseInt(this.select.value, 10);
      if (!id || this.chosen.length >= this.max) return;
      this.chosen.push(id);
      this.select.value = '';
      this.hideError();
      this.render();
    }

    onListClick(e) {
      var btn = e.target.closest('[data-advent-remove]');
      if (!btn) return;
      this.chosen.splice(parseInt(btn.dataset.adventRemove, 10), 1);
      this.hideError();
      this.render();
    }

    render() {
      var full = this.chosen.length >= this.max;
      this.select.disabled = full;
      this.addBtn.disabled = full || !this.select.value;

      this.list.innerHTML = '';
      var sum = 0;
      this.chosen.forEach(function (id, i) {
        var it = this.byId[id];
        sum += it.price;
        var li = document.createElement('li');
        li.className = 'advent-picker__item';
        li.innerHTML =
          (it.image ? '<img class="advent-picker__img" src="' + it.image + '" alt="" width="56" height="56">' : '<span class="advent-picker__img"></span>') +
          '<span class="advent-picker__name"></span>' +
          '<span class="advent-picker__price">' + fmt(it.price) + '</span>' +
          '<button type="button" class="advent-picker__remove link" data-advent-remove="' + i + '">Fjern</button>';
        li.querySelector('.advent-picker__name').textContent = (i + 1) + '. ' + this.label(it);
        this.list.appendChild(li);
      }, this);

      this.count.textContent = full
        ? 'Din kalender er fuld (' + this.max + '/' + this.max + ')'
        : this.chosen.length + ' af ' + this.max + ' valgt';
      this.total.textContent = fmt(sum);

      var missing = this.max - this.chosen.length;
      if (!this.boxAvailable || (this.chainVariant && !this.chainAvailable)) {
        this.submit.disabled = true;
        this.submitLabel.textContent = 'Udsolgt';
      } else if (missing > 0) {
        this.submit.disabled = true;
        this.submitLabel.textContent = missing === this.max ? 'Vælg ' + this.max + ' smykker' : 'Vælg ' + missing + ' mere';
      } else {
        this.submit.disabled = false;
        this.submitLabel.textContent = 'Læg adventskalenderen i kurven';
      }
    }

    showError(msg) {
      this.error.textContent = msg;
      this.error.hidden = false;
    }

    hideError() {
      this.error.hidden = true;
      this.error.textContent = '';
    }

    addToCart() {
      if (this.chosen.length !== this.max || !this.boxAvailable) return;
      if (this.chainVariant && !this.chainAvailable) return;
      var group = 'AK-' + Date.now().toString(36).toUpperCase();
      var names = this.chosen.map(function (id) {
        return this.label(this.byId[id]);
      }, this);

      var qty = {};
      this.chosen.forEach(function (id) {
        qty[id] = (qty[id] || 0) + 1;
      });

      var items = [
        {
          id: this.boxVariant,
          quantity: 1,
          properties: { Indhold: names.join(', '), _adventskalender: group, _adventskalender_aeske: '1' },
        },
      ];
      if (this.chainVariant) {
        items.push({ id: this.chainVariant, quantity: 1, properties: { _adventskalender: group, _adventskalender_kaede: '1' } });
      }
      Object.keys(qty).forEach(function (id) {
        items.push({ id: parseInt(id, 10), quantity: qty[id], properties: { _adventskalender: group } });
      });

      var self = this;
      this.submit.disabled = true;
      this.submit.classList.add('loading');
      this.hideError();

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok || data.status) throw new Error(data.description || data.message || 'Fejl');
            return data;
          });
        })
        .then(function () {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function (err) {
          self.submit.classList.remove('loading');
          self.render();
          self.showError('Adventskalenderen kunne ikke lægges i kurven: ' + err.message);
        });
    }
  }

  customElements.define('advent-picker', AdventPicker);
})();
